import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

type UseTestModeResult = {
  isTestMode: boolean;
};

export function useTestMode(): UseTestModeResult {
  const router = useRouter();
  const [isTestMode, setIsTestMode] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return sessionStorage.getItem('testmode') === 'true';
  });

  useEffect(() => {
    const { testmode } = router.query;

    if (!testmode) return;

    const password = Array.isArray(testmode) ? testmode[0] : testmode;

    fetch('/api/test-mode/activate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    })
      .then((res) => {
        if (res.ok) {
          sessionStorage.setItem('testmode', 'true');
          setIsTestMode(true);
        } else {
          console.warn('[useTestMode] Activation failed, status:', res.status);
        }
      })
      .catch((err) => {
        console.warn('[useTestMode] Activation request error:', err);
      });
  }, [router.query]);

  return { isTestMode };
}
